export enum PermissionLabel {
  ReadAllProjects = 'documentManagement.project.readAll',
  ReadProject = 'documentManagement.project.read',
  CreateProject = 'documentManagement.project.create',
  UpdateProject = 'documentManagement.project.update',
  DeleteProject = 'documentManagement.project.delete',
  ReadAllProjectDocuments = 'documentManagement.projectDocument.readAll',
  ReadProjectDocument = 'documentManagement.projectDocument.read',
  CreateProjectDocument = 'documentManagement.projectDocument.create',
  UpdateProjectDocument = 'documentManagement.projectDocument.update',
  DeleteProjectDocument = 'documentManagement.projectDocument.delete',
  ReadAllProjectWorkflows = 'documentManagement.projectWorkflow.readAll',
  ReadProjectWorkflow = 'documentManagement.projectWorkflow.read',
  CreateProjectWorkflow = 'documentManagement.projectWorkflow.create',
  UpdateProjectWorkflow = 'documentManagement.projectWorkflow.update',
  DeleteProjectWorkflow = 'documentManagement.projectWorkflow.delete',
  ReadAllProjectSettings = 'documentManagement.projectSetting.readAll',
  ReadProjectSetting = 'documentManagement.projectSetting.read',
  CreateProjectSetting = 'documentManagement.projectSetting.create',
  UpdateProjectSetting = 'documentManagement.projectSetting.update',
  DeleteProjectSetting = 'documentManagement.projectSetting.delete',
  ReadAllUserApprovals = 'documentManagement.userApproval.readAll',
  ReadUserApproval = 'documentManagement.userApproval.read',
  UpdateUserApproval = 'documentManagement.userApproval.update',
  ReadDashboard = 'documentManagement.dashboard.read',
  ReadMyTask = 'documentManagement.myTask.read',
  ReadProjectDashboard = 'documentManagement.projectDashboard.read',
  AccessMasterData = 'documentManagement.masterData.access',
  AccessStandardWorkflow = 'documentManagement.standardWorkflow.access'
}
